import type { ClientId } from '@nesso/ledger-contracts/ids';
import {
    SheetClose,
    SheetCloseButton,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from '@nesso/ui/primitives/sheet';

import { formatPaymentNumber, type Payment } from '@/entities/payment';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';
import { formatNumericShortDate } from '@/shared/lib/time-utils';
import { SheetBreadcrumb } from '@/shared/ui/panels/sheet-breadcrumb';

import { RefundPaymentSheetForm } from './refund-payment-sheet-content/refund-payment-sheet-form';

type Props = {
    clientId: ClientId;
    clientName: string;
    payment: Payment;
    onClose: () => void;
    onBreadcrumbNavigate: (navigate: () => void) => void;
    onPendingChange: (pending: boolean) => void;
};

export function RefundPaymentSheetContent({
    clientId,
    clientName,
    payment,
    onClose,
    onBreadcrumbNavigate,
    onPendingChange,
}: Props) {
    return (
        <>
            <SheetHeader variant="breadcrumbs" className="shrink-0">
                <SheetBreadcrumb
                    current="Refund"
                    getLabel={(sheet) =>
                        sheet.type === 'clients/details' && sheet.data.id === clientId
                            ? clientName
                            : undefined
                    }
                    onNavigate={onBreadcrumbNavigate}
                />
                <SheetClose asChild>
                    <SheetCloseButton className="ml-auto shrink-0" />
                </SheetClose>
            </SheetHeader>
            <SheetHeader variant="chart">
                <SheetTitle>Refund</SheetTitle>
                <SheetDescription>
                    {formatPaymentNumber(payment.number)}
                    {`, ${formatCurrencyFromCents(payment.amountCents)} on ${formatNumericShortDate(payment.paidAt)}`}
                </SheetDescription>
            </SheetHeader>
            <RefundPaymentSheetForm
                clientId={clientId}
                payment={payment}
                onClose={onClose}
                onPendingChange={onPendingChange}
            />
        </>
    );
}
